"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vodafoneTheme = void 0;
exports.vodafoneTheme = {
    logos: {
        memoresaLogoName: "logo_dark.png",
        memoresaLogotypeName: "logotype_dark.png",
        themeLogoName: ["vodafone.svg"],
    },
    background: { main: "#f4f4f4" },
    primary: {
        main: "#2e2e2e",
        contrast: "#fff",
    },
    secondary: {
        main: "#c60000",
        contrast: "#fff",
    },
    navbar: {
        bg: "white",
        color: "#e46450",
        hover: "#e46450",
    },
    fontFamily: "DroidSans",
};
